// extracted by mini-css-extract-plugin
export default {"tooltip__button":"Wu0mws","tooltip__content":"lT_MuS"};